"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBus = function SvgBus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 19 13"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.636 9.426h-8.34S0 9.54 0 8.108V1.292S.094 0 1.27 0h12.334s1.648-.03 1.95 1.58c.303 1.611.553 3.037.553 3.037S17 4.996 17 6.148v2.313s.029.943-.927.943c-.957 0-6.437.022-6.437.022z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.091,
    cy: 9.429,
    fill: "#FFF",
    rx: 1.545,
    ry: 1.571
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.909,
    cy: 9.429,
    fill: "#FFF",
    rx: 1.545,
    ry: 1.571
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.318,
    height: 2.143,
    x: 1.273,
    y: 2.071,
    fill: "#FFF",
    rx: 0.659
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.318,
    height: 2.143,
    x: 4.364,
    y: 2.071,
    fill: "#FFF",
    rx: 0.659
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.318,
    height: 2.143,
    x: 7.455,
    y: 2.071,
    fill: "#FFF",
    rx: 0.659
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.455 1.571h-1.81s-.496-.008-.496.562v1.996s-.142.585.517.585h2.586M10.05 9.452V2.408s-.139-.837 1.102-.837c1.24 0 1.212.628 1.212.628v7.253m-1.159-.023V1.964"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBus);
var _default = exports["default"] = Memo;